module.exports = __webpack_public_path__ + "img/three_dots.883a8c3e.svg";